import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { Section } from '@/entities/section';
import { SIDE_EDITOR_TOOLS_GAP } from '@/shared/constants/configurator';
import { DISPLAY_SCALE } from '@/shared/constants/editor';
import {
	calculateConfiguratorDepth,
	calculateConfiguratorHeight,
	calculateConfiguratorWidth,
	calculateRackDepth,
} from '@/shared/lib/configurator';
import { EditorSide, Section as ISection } from '@/shared/types/configurator';
import { Size } from '@/shared/ui/size/size';
import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
	SIDE_EDITOR_TOOLS_HEIGHT,
	SIDE_EDITOR_TOOLS_WIDTH,
} from '../../constants/editor.constants';
import { SideEditorSectionsConnection } from '../side-editor-sections-connection/side-editor-sections-connection';
import styles from './side-editor.module.css';

export const SideEditor = () => {
	const {
		state: { doubleSided, sections, wallMounted },
		updateOptions,
	} = useConfigurator();
	const { t } = useTranslation();

	const height = calculateConfiguratorHeight(sections);
	const rackDepth = calculateRackDepth(sections);
	const depth = calculateConfiguratorDepth(sections, doubleSided);
	const width = calculateConfiguratorWidth(sections, wallMounted);

	const displaySection: ISection = {
		depth: rackDepth,
		height,
		width: 0,
		selfs: [],
	};

	return (
		<div
			style={{
				width: width * DISPLAY_SCALE + SIDE_EDITOR_TOOLS_WIDTH,
				height:
					height * DISPLAY_SCALE +
					SIDE_EDITOR_TOOLS_HEIGHT +
					SIDE_EDITOR_TOOLS_HEIGHT +
					SIDE_EDITOR_TOOLS_GAP,
			}}
			className={styles.wrapper}
		>
			<Size
				style={{ height: height * DISPLAY_SCALE }}
				value={`${height} ${t('units.mm')}`}
				label={t('size.height.rackTitle')}
				className={styles.heightSize}
				type="height"
			/>
			<Size
				style={{ width: depth * DISPLAY_SCALE }}
				value={`${depth} ${t('units.mm')}`}
				className={styles.depthSize}
				type="width"
			/>
			<Size
				options={{ rotate: -35, labelClassName: styles.widthLabel }}
				value={`${width} ${t('units.mm')}`}
				className={styles.widthSize}
				label={t('size.width.rackTitle')}
				type="rotate"
			/>
			<div className={styles.sections}>
				<Section side={EditorSide.SIDE} section={displaySection} sectionIndex={0} />
				{doubleSided ? (
					<>
						<SideEditorSectionsConnection />
						<Section side={EditorSide.SIDE} section={displaySection} sectionIndex={0} />
					</>
				) : (
					<div
						style={{ height: height * DISPLAY_SCALE }}
						className={styles.addSectionButtonWrapper}
					>
						<button
							className={styles.addSectionButton}
							onClick={() => updateOptions({ doubleSided: true })}
						>
							<PlusIcon size={20} color="white" />
						</button>
					</div>
				)}
			</div>
		</div>
	);
};
